import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import { TitleComponent } from '_components/TitleComponent/TitleComponent';
import {ActionButtons} from "_components/ActionButtons/ActionButtons";
import {PageCopy} from "_components/PageCopy/PageCopy";
import PageFlow from "_pages/__routes/PageFlow";
import {CustomContent} from '_pages/Variations/CustomContent/CustomContent';
import {PageBackgroundImages} from "_components/PageBackgroundImages/PageBackgroundImages";
import {UniversalComponents} from "_components/_UniversalComponents/UniversalComponents";

import { useActionExecutor } from "__globals/appActions";
import * as GC from "__globals/GLOBAL-CONSTANTS";

import {
    empty,
    logIt
} from '__globals/global-functions';

/** IS THIS WORKING...TOOK IT OUT EVERYWHERE FOR NOW
 * import TagManager from "react-gtm-module";
 *
 * const tagManagerArgs = {
 * 	dataLayer: {
 * 		userId: '001',
 * 		userProject: 'RSP',
 * 		page: 'OfficialRules',
 * 		checkLoginIframe: false
 * 	},
 * 	dataLayerName: 'RSP'
 * }
 *
 * THIS IS WHAT WAS ON THE PAGE: TagManager.dataLayer(tagManagerArgs);
 */

export const TemplatePage = props => {

    const { execute } = useActionExecutor();

    logIt(GC.PAGE_TEMPLATE + " PAGE IS CALLED", null, false);
    const PAGE_DIV_NAME = "template"; // use underscores
    const PAGE_KEY = "template"; // use camel case
    const PAGE_IMAGE_KEY = "template"; // use dashes

    const promotion = useSelector(state => state.promotion);
    //logIt( "PROMOTION at " + GC.PAGE_TEMPLATE, promotion, true );

    // LOCAL VARIABLES
    const [action, setAction] = useState('');
    const [value, setValue] = useState('');
    const [goNext, setGoNext] = useState(false);

    const doAction = (a, v) => {
        if (a.toUpperCase().trim() === GC.ACTION_NAVIGATE) {
            setAction(a);
            setValue(v);
            setGoNext(true);
        } else {
            execute({ type: a, value: v } );
        }
    }

    if (goNext) {

        return (<PageFlow page={GC.PAGE_TEMPLATE} error={null} action={action} value={value}/>);

    } else {

        return (
            <React.Fragment>
                <TitleComponent title={promotion.configuration.promoCopy.GLOBAL.title}/>
                <div id={PAGE_DIV_NAME + "_page"}>

                    <table>
                        <tbody>
                        <tr>
                            <td className="page-visual">

                                <PageBackgroundImages
                                    promotion={promotion}
                                    pageKey={PAGE_IMAGE_KEY}
                                />

                            </td>
                            <td className="page-content">

                                <div id={PAGE_DIV_NAME + "_content"}>

                                    <PageCopy
                                        promotion={promotion}
                                        configKey={PAGE_KEY}
                                        jsonKey={PAGE_JSON_KEY}
                                    />

                                    STUFF ON PAGE

                                    <ActionButtons
                                        promotion={promotion}
                                        configKey={PAGE_KEY}
                                        jsonKey={PAGE_JSON_KEY}
                                        doAction={doAction}
                                    />

                                </div>

                                <UniversalComponents
                                    promotion={promotion}
                                    configKey={PAGE_KEY}
                                />

                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <CustomContent/>

                </div>

            </React.Fragment>

        );

    }

}